import { FeedbackOption } from "./option";
import { HStack, StackProps, useRadioGroup } from "@chakra-ui/react";

interface RadioGroupProps extends Omit<StackProps, "onChange"> {
  name: string;
  options: string[];
  onChange: (value: string) => void;
}

export const FeedbackRadioGroup = (props: RadioGroupProps) => {
  const { name, options, onChange, ...rest } = props;
  const { getRootProps, getRadioProps } = useRadioGroup({
    name,
    onChange,
  });

  return (
    <HStack {...getRootProps(rest)}>
      {options.map((value, idx) => (
        <FeedbackOption
          key={value}
          id={`feedback-emoji-${idx}`}
          {...getRadioProps({ value })}
          className={`reaction-${idx}`}
        >
          {value}
        </FeedbackOption>
      ))}
    </HStack>
  );
};
